import { useFilterStore } from "../stores/receiptFilterStore";

const useReceiptFilters = () => {
  const filters = useFilterStore((s) => s.filters);
  const setFilter = useFilterStore((s) => s.setFilter);
  const resetFilters = useFilterStore((s) => s.resetFilters);
  return { filters, setFilter, resetFilters };
};

export default useReceiptFilters;
